import PageContentWrapper from 'shared/components/PageContentWrapper'
import {
  VStack,
  Text,
  HStack,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Table,
  TableContainer,
  Thead,
  Tr,
  Link,
  Tbody,
  Td
} from '@chakra-ui/react'
import ContentContainer from 'shared/components/ContentContainer'
import BlackPageHeader from 'components/BlackPageHeader'
import { ReactNode } from 'react'

type ISection = {
  title: string
  content: ReactNode[][]
}

const Info = () => {
  const data: ISection[] = [
    {
      title: 'Основные сведения',
      content: [
        [
          'о полном и сокращенном (при наличии) наименовании образовательной организации (п.3.1 Требований от 14.08.2020 № 831);',
          'Индивидуальный предприниматель Остроухова Маргарита Сергеевна',
          ' Уведомление о постановке на учет в ФНС'
        ],
        [
          'о дате создания образовательной организации (пп. «а» п.1.ч.2 ст. 29 273-ФЗ; п. 3.1.Требований от 14.08.2020 № 831);',
          '08.05.2020',
          'Лист записи ЕГРЮЛ'
        ],
        [
          'об учредителе (учредителях) образовательной организации  (пп. «а» п.1.ч.2 ст. 29 273-ФЗ; п. 3.1.Требований от 14.08.2020 № 831);',
          'Остроухова Маргарита Сергеевна',
          ''
        ],
        [
          'о наименовании представительств и филиалов образовательной организации (при наличии) (в том числе, находящихся за пределами Российской Федерации)  (пп. «а» п.1.ч.2 ст. 29 273-ФЗ,  п.3.1 Требований от 14.08.2020 № 831);',
          'Представительства и филиалы отсутствуют',
          ''
        ],
        [
          'о месте нахождения образовательной организации, ее представительств и  филиалов (при наличии)  (пп. «а» п.1.ч.2 ст. 29 273-ФЗ; п. 3.1.Требований от 14.08.2020 № 831);',
          '144012, Россия, Московская обл., г. Электросталь, ул. Николаева, д. 50, кв. 5',
          ''
        ],
        [
          'о режиме и графике работы образовательной организации, ее представительств и  филиалов (при наличии)  (пп. «а» п.1.ч.2 ст. 29 273-ФЗ; п. 3.1.Требований от 14.08.2020 № 831);',
          '',
          ''
        ],
        [
          'о контактных телефонах и об адресах электронной почты образовательной организации, ее представительств и  филиалов(при наличии)   (пп. «а» п.1.ч.2 ст. 29 273-ФЗ; п. 3.1.Требований от 14.08.2020 № 831);',
          '',
          ''
        ],
        [
          'об адресах официальных сайтов представительств и филиалов образовательной организации (при наличии) или страницах в информационно-телекоммуникационной сети “Интернет”  (п.3.1 Требований от 14.08.2020 № 831);',
          '',
          ''
        ],
        [
          'о местах осуществления образовательной деятельности, в том числе не указанных в приложении к лицензии (реестре лицензий) на осуществление образовательной деятельности в соответствии с ч. 4 ст. 91 273-ФЗ (пп. «з.1» п.1.ч.2 ст. 29 273-ФЗ; п. 3.1 Требований от 14.08.2020 № 831), в том числе: –   места осуществления образовательной деятельности по дополнительным образовательным программам (в.т.ч. пп. «а» п. 12 постановления от 20.10.2021 № 1802); – места осуществления образовательной деятельности при использовании сетевой формы реализации образовательных программ (в.т.ч. пп. «а» п. 12 постановления от 20.10.2021 № 1802); – места проведения практической подготовки обучающихся (в.т.ч. пп. «а» п. 12 постановления от 20.10.2021 № 1802).',
          'Осуществление образовательной деятельности осуществляется дистанционно',
          <Link
            href='https://firebasestorage.googleapis.com/v0/b/admin-dev-33fc2.appspot.com/o/docs%2F%D0%9F%D0%9E%D0%9B%D0%9E%D0%96%D0%95%D0%9D%D0%98%D0%95_%D0%BE_%D0%BF%D0%BE%D1%80%D1%8F%D0%B4%D0%BA%D0%B5_%D0%BF%D1%80%D0%B8%D0%BC%D0%B5%D0%BD%D0%B5%D0%BD%D0%B8%D1%8F_%D1%8D%D0%BB%D0%B5%D0%BA%D1%82%D1%80%D0%BE%D0%BD%D0%BD%D0%BE%D0%B3%D0%BE_%D0%BE%D0%B1%D1%83%D1%87%D0%B5%D0%BD%D0%B8%D1%8F.pdf?alt=media&token=6761fa52-4c3b-4a75-acdb-c45d038b25ad'
            isExternal
          >
            Положение о порядке применения электронного обучения и дистанционных
            образовательных технологий при реализации дополнительных
            общеобразовательных общеразвивающих программ
          </Link>
        ]
      ]
    },
    {
      title: 'Структура и органы управления образовательной организацией',
      content: [
        [
          'О структуре и об органах управления образовательной организацией (пп. «б» п.1.ч.2 ст. 29 273-ФЗ), в том числе:– наименование структурных подразделений (органов управления) (пп. «а» п. 4 постановления от 20.10.2021 № 1802);– фамилии, имена, отчества (при наличии) и должности руководителей структурных подразделений (пп. «б» п. 4 постановления от 20.10.2021 № 1802; п. 3.2 Требований от 14.08.2020 № 831);– о местах нахождения структурных подразделений (органов управления) образовательной организации (при наличии структурных подразделений (органов управления) (пп. «в» п. 4 постановления от 20.10.2021 № 1802; п. 3.2 Требований от 14.08.2020 № 831);– об адресах официальных сайтов в информационно-телекоммуникационной сети “Интернет” структурных подразделений (органов управления) образовательной организации (при наличии официальных сайтов) (пп. «г» п. 4 постановления от 20.10.2021 № 1802; п. 3.2 Требований от 14.08.2020 № 831);– об адресах электронной почты структурных подразделений (органов управления) образовательной организации (при наличии электронной почты) (пп. «д» п. 4 постановления от 20.10.2021 № 1802; п. 3.2 Требований от 14.08.2020 № 831).',
          'Управление образовательной организацией осуществляется единоличноИндивидуальным предпринимателем Остроуховой Маргаритой Сергеевной. Органы управления расположены по адресу: 144012, Россия, Московская обл., г. Электросталь, ул. Николаева, д. 50, кв. 5. Электронная почта sabina.saislamova@bk.ru'
        ],
        [
          'сведения о наличии положений о структурных подразделениях (об органах управления) с приложением указанных положений в виде электронных документов, подписанных простой электронной подписью в соответствии с Федеральным законом РФ от 6 апреля 2011 г. № 63-ФЗ «Об электронной подписи».',
          'Не имеется'
        ]
      ]
    },
    {
      title: 'Документы',
      content: [
        [
          'Устав образовательной организации (пп. «а» п. 2 ч. 2 ст. 29 273-ФЗ; п. 3.3. Требований от 14.08.2020 № 831);',
          'Не имеется'
        ],
        [
          'изменений, вносимых в устав образовательной организации (пп. 1 п. 3.3 ст. 32 Федерального закона РФ от 12.01.1996 г. № 7-ФЗ «О некоммерческих организациях»);',
          'Не имеется'
        ],
        [
          'Свидетельство о государственной регистрации государственной (муниципальной) организации (пп. 2 п. 3.3. ст. 32 Федерального закона РФ от 12.01.1996 г. № 7-ФЗ «О некоммерческих организациях»);',
          'Лист записи ЕГРЮЛ',
          'Лист записи ЕГРЮЛ'
        ],
        [
          'решение учредителя о создании государственной (муниципальной) организации  (пп. 3 п. 3.3. ст. 32 Федерального закона РФ от 12.01.1996 г. № 7-ФЗ «О некоммерческих организациях»);',
          'Не имеется'
        ],
        [
          'решение учредителя о назначении руководителя государственной (муниципальной) организации  (пп. 4 п. 3.3. ст. 32 Федерального закона РФ от 12.01.1996 г. № 7-ФЗ «О некоммерческих организациях»);',
          'Не имеется'
        ],
        [
          'правила внутреннего распорядка обучающихся  (пп. «д» п. 2 ч. 2 ст. 29 273-ФЗ; п. 3.3. Требований от 14.08.2020 № 831);',
          'Имеется',
          <Link
            href='https://firebasestorage.googleapis.com/v0/b/admin-dev-33fc2.appspot.com/o/docs%2F%D0%9F%D0%9E%D0%9B%D0%9E%D0%96%D0%95%D0%9D%D0%98%D0%95_%D0%BE_%D0%BF%D0%BE%D1%80%D1%8F%D0%B4%D0%BA%D0%B5_%D0%BF%D1%80%D0%B8%D0%BC%D0%B5%D0%BD%D0%B5%D0%BD%D0%B8%D1%8F_%D1%8D%D0%BB%D0%B5%D0%BA%D1%82%D1%80%D0%BE%D0%BD%D0%BD%D0%BE%D0%B3%D0%BE_%D0%BE%D0%B1%D1%83%D1%87%D0%B5%D0%BD%D0%B8%D1%8F.pdf?alt=media&token=6761fa52-4c3b-4a75-acdb-c45d038b25ad'
            isExternal
          >
            Положение о порядке применения электронного обучения и дистанционных
            образовательных технологий при реализации дополнительных
            общеобразовательных общеразвивающих программ
          </Link>
        ],
        [
          'правила внутреннего трудового распорядка  (пп. «д» п. 2 ч. 2 ст. 29 273-ФЗ; п. 3.3. Требований от 14.08.2020 № 831);',
          'Не имеется'
        ],
        [
          'коллективного договора (при наличии)  (пп. «д» п. 2 ч. 2 ст. 29 273-ФЗ; п. 3.3. Требований от 14.08.2020 № 831);',
          'Не имеется'
        ],
        ['отчет о результатах самообследования;', 'Не имеется'],
        [
          'предписания органов, осуществляющих государственный контроль (надзор) в сфере образования, отчеты об исполнении таких предписаний (до подтверждения органом, осуществляющим государственный контроль (надзор) в сфере образования, исполнения предписания или признания его недействительным в установленном законом порядке) (при наличии)',
          'Не имеется'
        ],
        [
          'локальные нормативные акты, предусмотренные частью 2 статьи 30 273-ФЗ: – правила приема обучающихся, в т.ч. порядок оформления возникновения отношений между образовательной организацией и обучающимися и (или) родителями (законными представителями) несовершеннолетних обучающихся; (ч.2 ст.30 273-ФЗ),  – режим занятий обучающихся (ч.2 ст.30 273-ФЗ),  – формы, периодичность и порядок промежуточной аттестации обучающихся (ч.2 ст.30 273-ФЗ),  – порядок и основания перевода обучающихся внутри образовательной организации (ч.2 ст.30 273-ФЗ),  – порядок и основания отчисления, в том числе порядок оформления прекращения отношений между образовательной организацией и обучающимися и (или) родителями (законными представителями) несовершеннолетних обучающихся (ч.2 ст.30 273-ФЗ),  – порядок оформления приостановления отношений между образовательной организацией и обучающимися и (или) родителями (законными представителями) несовершеннолетних обучающихся (ч.2 ст.30 273-ФЗ).',
          'имеется',
          <VStack>
            <Link
              href='https://firebasestorage.googleapis.com/v0/b/admin-dev-33fc2.appspot.com/o/docs%2F%D0%9F%D0%9E%D0%9B%D0%9E%D0%96%D0%95%D0%9D%D0%98%D0%95_%D0%BE_%D0%BF%D0%BE%D1%80%D1%8F%D0%B4%D0%BA%D0%B5_%D0%BE%D0%BA%D0%B0%D0%B7%D0%B0%D0%BD%D0%B8%D1%8F_%D0%BF%D0%BB%D0%B0%D1%82%D0%BD%D1%8B%D1%85_%D0%BE%D0%B1%D1%80%D0%B0%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D1%85_%D1%83%D1%81%D0%BB%D1%83%D0%B3.pdf?alt=media&token=8f806fbe-6bf6-4bae-b7df-58a366016c59'
              isExternal
            >
              ПОЛОЖЕНИЕ о порядке оказания платных образовательных услуг
            </Link>

            <Link
              href='https://firebasestorage.googleapis.com/v0/b/admin-dev-33fc2.appspot.com/o/docs%2F%D0%9F%D0%BE%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%BE%D0%B1%20%D0%BE%D1%80%D0%B3%D0%B0%D0%BD%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D0%B8%20%D0%94%D0%9E.pdf?alt=media&token=800e789a-9c6f-459b-bc93-bcb1884a95fe'
              isExternal
            >
              ПОЛОЖЕНИЕ об организации дополнительного образования детей и
              взрослых
            </Link>

            <Link
              href='https://firebasestorage.googleapis.com/v0/b/admin-dev-33fc2.appspot.com/o/docs%2F%D0%9F%D1%80%D0%B8%D0%BA%D0%B0%D0%B7%20%D0%9E%D0%B1%20%D1%83%D1%82%D0%B2%D0%B5%D1%80%D0%B6%D0%B4%D0%B5%D0%BD%D0%B8%D0%B8%20%D0%BA%D0%BE%D0%BC%D0%B8%D1%81%D1%81%D0%B8%D0%B8.pdf?alt=media&token=9bfa9409-b53f-4d9f-a0e7-384d12618a7e'
              isExternal
            >
              ПОЛОЖЕНИЕ О КОМИССИИ ПО УРЕГУЛИРОВАНИЮ СПОРОВ между участниками
              образовательных отношений в ИП Остроухова Маргарита Сергеевна
            </Link>

            <Text>
              ПОЛОЖЕНИЕ о формах, периодичности и порядке текущего контроля
              успеваемости, промежуточной и итоговой аттестации слушателей по
              дополнительным общеразвивающим общеобразовательным программам
              <br />
              ПОРЯДОК оформления возникновения, приостановления и прекращения
              образовательных отношений между ИП Остроухова Маргарита Сергеевна
              и обучающимися (слушателями)
            </Text>
          </VStack>
        ]
      ]
    },
    {
      title: 'Образование',
      content: [
        [
          'Информация о лицензии на осуществление образовательной деятельности (выписка из реестра лицензий на осуществление образовательной деятельности)',
          'Имеется',
          'Выписка из реестра лицензий на осуществление образовательной деятельности'
        ],
        [
          'О наименовании образовательной программы (пп. «в» п. 3.4. Требований от 14.08.2020 № 831) (пп. «а» п. 5 постановления от 20.10.2021 № 1082);',
          'Дополнительная общеобразовательная общеразвивающая программа «Британский акцент»',
          <Link
            href='https://firebasestorage.googleapis.com/v0/b/admin-dev-33fc2.appspot.com/o/docs%2F%D0%9F%D0%A0%D0%9E%D0%93%D0%A0%D0%90%D0%9C%D0%9C%D0%90%20%D0%B1%D1%80%D0%B8%D1%82%D0%B0%D0%BD%D1%81%D0%BA%D0%B8%D0%B8%CC%86%20%D0%B0%D0%BA%D1%86%D0%B5%D0%BD%D1%82.pdf?alt=media&token=12887538-ce42-4e8d-a37e-34fc655c9717'
            isExternal
          >
            Программа обучения
          </Link>
        ],
        [
          'О форме обучения (за исключением образовательных программ дошкольного образования) (п. «б» п. 5 постановления от 20.10.2021 № 1082);',
          'Обучение осуществляется дистанционно'
        ],
        [
          'О нормативном сроке обучения (п. «в» п. 5 постановления от 20.10.2021 № 1082; п. 3.4. Требований от 14.08.2020 № 831);',
          '84 академических часа'
        ],
        [
          'О сроке действия государственной аккредитации образовательной программы (при наличии государственной аккредитации), общественной, профессионально-общественной аккредитации образовательной программы (при наличии общественной, профессионально-общественной аккредитации) (п. 3.4. Требований от 14.08.2020 № 831);',
          'Не имеется'
        ],
        [
          'О языка(х), на котором(ых) осуществляется образование (обучение) (пп. «д» п.1 ч. 2 ст. 29 273-ФЗ; п. 3.4. Требований от 14.08.2020 № 831);*Информация, указанная в подпункте «д» пункта 1 части 2 статьи 29 Федерального закона «Об образовании в Российской Федерации", размещается в форме электронного документа, подписанного простой электронной подписью в соответствии с Федеральным законом «Об электронной подписи», с приложением к каждой образовательной программе.',
          'Русский и английский языки'
        ],
        [
          'Об использовании при реализации образовательной программы электронного обучения и дистанционных образовательных технологий (п. 3.4. Требований от 14.08.2020 № 831);',
          'Реализация настоящей образовательной программы с использованием электронного обучения и дистанционных образовательных технологий предполагает наличие специализированной образовательной платформы для электронного обучения. Требования к рабочему месту педагогического работника, реализующего настоящую дополнительную общеразвивающую программу, определяются соответствующим локальным нормативным актом Индивидуального предпринимателя Остроуховой Маргариты Сергеевны. К оборудованию и технологическому оснащению рабочих мест относится выход в сеть Интернет. Используется телекоммуникационная сеть Интернет через установленные программно-технические средства на скорости не ниже 512 Кбит/с, скоростью прямого канала не ниже 512 Кбит/с, скоростью обратного канала не ниже 128 Кбит/с, использованием порта доступа в сеть Интернет со скоростью не ниже 30 Мбит/с и возможностью установления не менее 20 одновременных сессий по 512 Кбит/с. Услуга подключения к сети Интернет предоставляется Индивидуальному предпринимателю Остроуховой Маргарите Сергеевне в режиме 24 часа в сутки 7 дней в неделю без учёта объёмов потребляемого трафика за исключением перерывов для проведения необходимых ремонтных и профилактических работ при обеспечении совокупной доступности услуг не менее 99,5 % в месяц.'
        ],
        [
          'Об описании образовательной программы с приложением образовательной программы в форме электронного документа или в виде активных ссылок, непосредственный переход по которым позволяет получить доступ к страницам Сайта, содержащим информацию, указанную в пп. "б" п 3.4 Требований от 14.08.2020 № 831, в том числе: - об учебном плане с приложением его в виде электронного документа (при наличии); - об аннотации к рабочим программам дисциплин (по каждому учебному предмету, курсу, дисциплине (модулю), практики, в составе образовательной программы) с приложением рабочих программ в виде электронного документа (при наличии); - о календарном учебном графике с приложением его в виде электронного документа;- о методических и иных документах, разработанных образовательной организацией для обеспечения образовательного процесса, в виде электронного документа;',
          'Учебный план Календарный учебный график ПОЛОЖЕНИЕ о порядке применения электронного обучения и дистанционных образовательных технологий при реализации дополнительных общеобразовательных общеразвивающих программ',
          <VStack>
            <Link
              href='https://firebasestorage.googleapis.com/v0/b/admin-dev-33fc2.appspot.com/o/docs%2F%D0%9A%D0%90%D0%9B%D0%95%D0%9D%D0%94%D0%90%D0%A0%D0%9D%D0%9E-%D0%A3%D0%A7%D0%95%D0%91%D0%9D%D0%AB%D0%98%CC%86%20%D0%9F%D0%9B%D0%90%D0%9D.docx?alt=media&token=5bdc2d6b-b62c-47e1-8e33-0c7dc9320872'
              isExternal
            >
              КАЛЕНДАРНО-УЧЕБНЫЙ ПЛАН
            </Link>
            <Link
              href='https://firebasestorage.googleapis.com/v0/b/admin-dev-33fc2.appspot.com/o/docs%2F%D0%9A%D0%90%D0%9B%D0%95%D0%9D%D0%94%D0%90%D0%A0%D0%9D%D0%9E_%D0%A3%D0%A7%D0%95%D0%91%D0%9D%D0%AB%D0%98%CC%86_%D0%9F%D0%9B%D0%90%D0%9D_%D0%9D%D0%90_2022_%D0%93%D0%9E%D0%94.docx?alt=media&token=a4891c57-08b3-4b76-b601-fe4276804322'
              isExternal
            >
              КАЛЕНДАРНО-УЧЕБНЫЙ ПЛАН - 2022
            </Link>
            <Link
              href='https://firebasestorage.googleapis.com/v0/b/admin-dev-33fc2.appspot.com/o/docs%2F%D0%9F%D0%9E%D0%9B%D0%9E%D0%96%D0%95%D0%9D%D0%98%D0%95_%D0%BE_%D0%BF%D0%BE%D1%80%D1%8F%D0%B4%D0%BA%D0%B5_%D0%BF%D1%80%D0%B8%D0%BC%D0%B5%D0%BD%D0%B5%D0%BD%D0%B8%D1%8F_%D1%8D%D0%BB%D0%B5%D0%BA%D1%82%D1%80%D0%BE%D0%BD%D0%BD%D0%BE%D0%B3%D0%BE_%D0%BE%D0%B1%D1%83%D1%87%D0%B5%D0%BD%D0%B8%D1%8F.pdf?alt=media&token=6761fa52-4c3b-4a75-acdb-c45d038b25ad'
              isExternal
            >
              Положение о порядке применения электронного обучения и
              дистанционных образовательных технологий при реализации
              дополнительных общеобразовательных общеразвивающих программ
            </Link>
          </VStack>
        ],
        [
          'о численности обучающихся по реализуемым образовательным  программам, в том числе:  – об общей численности обучающихся',
          'Не имеется'
        ],
        [
          '-* о численности обучающихся за счет бюджетных ассигнований федерального бюджета;',
          'Не имеется'
        ],
        [
          '-* о численности обучающихся за счет бюджетных ассигнований бюджетов субъектов Российской Федерации;',
          'Не имеется'
        ],
        [
          '– *о численности обучающихся за счет бюджетных ассигнований местных бюджетов;',
          'Не имеется'
        ],
        [
          '– *о численности обучающихся по договорам об образовании, заключаемых при приеме на обучение за счет средств физического и (или) юридического лица 	',
          'Не имеется'
        ],
        [
          'Об описании образовательной программы с приложением образовательной программы в форме электронного документа или в виде активных ссылок, непосредственный переход по которым позволяет получить доступ к страницам Сайта, содержащим информацию, указанную в пп. "б" п 3.4 Требований от 14.08.2020 № 831, в том числе: - об учебном плане с приложением его в виде электронного документа (при наличии); - об аннотации к рабочим программам дисциплин (по каждому учебному предмету, курсу, дисциплине (модулю), практики, в составе образовательной программы) с приложением рабочих программ в виде электронного документа (при наличии); - о календарном учебном графике с приложением его в виде электронного документа;- о методических и иных документах, разработанных образовательной организацией для обеспечения образовательного процесса, в виде электронного документа;',
          'Программа разработана в соответствии с требованиями: Федеральный Закон Российской Федерации от 29.12.2012 № 273 «Об образовании в Российской Федерации» (далее – ФЗ № 273); Приказ Министерства просвещения Российской Федерации от 09.11.2018 № 196 «Об утверждении порядка организации и осуществления образовательной деятельности по дополнительным общеобразовательным программам»; Распоряжение Правительства РФ от 31.03.2022 № 678-р «Об утверждении Концепции развития дополнительного образования детей и признании утратившим силу Распоряжения Правительства РФ от 04.09.2014 № 1726-р» (вместе с «Концепцией развития дополнительного образования детей до 2030 года»); Письмо Минобрнауки России от 18.11.2015 № 09-3242 «Методические рекомендации по проектированию дополнительных общеразвивающих программ»; Методические рекомендации по реализации образовательных программ начального, общего, основного общего, среднего общего образования, образовательных программ среднего профессионального образования и дополнительных общеобразовательных программ с применением ЭО и ДОТ» от 20.03.2020. Цель реализации программы: овладение студентами основами теории фонетики в тесной связи с практическим применением, что будет способствовать совершенствованию их навыков владения речью, осуществлению коммуникации, пониманию английской речи и корректному произношению. Основными задачами программы являются: овладение теоретическими основами работы артикуляционного аппарата в английском языке; обобщение и углубление знаний фонетики, полученные студентами при изучении английского языка; формирование базовых понятий практической фонетики английского языка; выработка умений и практических навыков отработки фонетических особенностей английского языка; формирование звуко-произносительных и ритмико-интонационных фонетических навыков, способствующих корректному английскому произношению; овладение базовыми правилами чтения в английском языке. Категория обучающихся: лица, достигшие 18 лет и старше. К освоению программы допускаются: лица, достигшие 18 лет и старше, имеющие начальный, базовый и повышенный уровень владения английским языком без предъявления требований к уровню образования. Объем программы: 84 академических часа обучения, из них: лекционных занятий – 18,5 ак. часов; практических занятий – 16,5 ак. часов; самостоятельная работа – 47 ак. часов; форма контроля – итоговая аттестация в виде зачета (2 ак. часа). Продолжительность обучения – 3,5 месяца. Форма обучения - дистанционная. Обучение проводится на русском и английском языках. После завершения обучения по программе выдается диплом или свидетельство о получении дополнительного образования.'
        ]
      ]
    },
    {
      title: 'Руководство. Педагогический (научно-педагогический) состав',
      content: [
        [
          'О руководителе образовательной организации, в том числе:- фамилия, имя, отчество (при наличии) руководителя,- наименование должности руководителя,- контактные телефоны,- адреса электронной почты.',
          'Индивидуальный предприниматель Остроухова Маргарита Сергеевна. Электронная почта: maggie1000@mail.ru',
          ''
        ],
        [
          'О заместителях руководителя образовательной организации (при наличии), в том числе:- фамилия, имя, отчество (при наличии) заместителя руководителя,- наименование должности руководителя,- контактные телефоны,- адреса электронной почты.',
          'Не имеется'
        ],
        [
          'о руководителях филиалов, представительств образовательной организации (при наличии), в том числе: фамилия, имя, отчество (при наличии), – наименование должности руководителя, – контактные телефоны, – адреса электронной почты.',
          'Не имеется'
        ],
        [
          'о персональном составе педагогических работников каждой реализуемой образовательной программы в форме электронного документа или в виде активных ссылок, непосредственный переход по которым позволяет получить доступ к страницам Сайта, содержащим следующую информацию: – фамилия, имя, отчество (при наличии) педагогического работника; – занимаемая должность (должности); – преподаваемые учебные предметы, курсы, дисциплины (модули), – уровень (уровни) профессионального образования с указанием наименования направления подготовки и (или) специальности, в том числе научной; – квалификация; – ученая степень (при наличии); – ученое звание (при наличии); – сведения о повышении квалификации (за последние 3 года); – сведения о профессиональной переподготовке (при наличии); – сведения о продолжительности опыта (лет) работы в профессиональной сфере, соответствующей образовательной деятельности по реализации учебных предметов, курсов, дисциплин (модулей) (общий стаж работы, стаж работы по специальности – только по п. «г»  п. 3.6 Требований от 14.08.2020 № 831).  -наименование образовательных программм в реализации которых участвует педагогический работник.',
          'Не имеется'
        ]
      ]
    },
    {
      title:
        'Материально-техническое обеспечение и оснащенность образовательного процесса',
      content: [
        [
          'Информация о материально-техническом обеспечении образовательной деятельности',
          'пп. «и» п.1 ч. 2  статьи 29  273-ФЗ, п.3.7 Требований к структуре официального сайта образовательной организации в информационно – телекоммуникационной сети «Интернет» и формату представления на нем информации, утвержденных Приказом Федеральной службы по надзору в сфере образования и науки от 14.08.2020 № 831.'
        ],
        [
          'Сведения о материально-техническом обеспечении образовательной деятельности, в том числе: об оборудованных учебных кабинетах; об объектах для проведения практических занятий; о библиотеке(ах); об объектах спорта; о средствах обучения и воспитания; об условиях охраны здоровья обучающихся; о доступе к информационным системам и информационно-телекоммуникационным сетям; об электронных образовательных ресурсах, к которым обеспечивается доступ обучающихся, в том числе: о собственных электронных образовательных и информационных ресурсах (при наличии); о сторонних электронных образовательных и информационных ресурсах (при наличии).'
        ]
      ]
    },
    {
      title: 'Платные образовательные услуги',
      content: [
        [
          'документа о порядке оказания платных образовательных услуг, в том числе образец договора об оказании платных образовательных услуг;',
          'оферта на оказание платных образовательных услуг',
          <Link href='/contract'>Договор-оферта</Link>
        ],
        [
          'документа об утверждении стоимости обучения по каждой образовательной программе;',
          'Об утверждении стоимости платных образовательных услуг в 2023 году',
          <Link
            href='https://firebasestorage.googleapis.com/v0/b/admin-dev-33fc2.appspot.com/o/docs%2F%D0%9F%D1%80%D0%B8%D0%BA%D0%B0%D0%B7%20%D0%9E%D0%B1%20%D1%83%D1%82%D0%B2%D0%B5%D1%80%D0%B6%D0%B4%D0%B5%D0%BD%D0%B8%D0%B8%20%D1%81%D1%82%D0%BE%D0%B8%D0%BC%D0%BE%D1%81%D1%82%D0%B8.docx?alt=media&token=a53c76a1-b60c-4da3-82cf-b5d8eb8b92c2'
            isExternal
          >
            Об утверждении стоимости платных образовательных услуг в 2023 году
          </Link>
        ]
      ]
    },
    {
      title: 'Финансово-хозяйственная деятельность',
      content: [
        [
          'информацию об объеме образовательной деятельности, финансовое обеспечение которой осуществляется: – за счет бюджетных ассигнований федерального бюджета; – за счет бюджетов субъектов Российской Федерации; – за счет местных бюджетов; – по договорам об оказании платных образовательных услуг (пп. «п» п. 1 ч. 2 ст. 29 273-ФЗ;  п. «а» п. 3.10 Требований от 14.08.2020 № 831);',
          'Не имеется'
        ],
        [
          'информацию о поступлении финансовых и материальных средств по итогам финансового года  (пп. «р» п. 1 ч. 2 ст. 29 273-ФЗ;  п. «б» п. 3.10 Требований от 14.08.2020 № 831);	'
        ],
        [
          'информацию о расходовании финансовых и материальных средств по итогам финансового года  (пп. «р» п. 1 ч. 2 ст. 29 273-ФЗ;  п. «в» п. 3.10 Требований от 14.08.2020 № 831);	'
        ],
        [
          'копию плана финансово-хозяйственной деятельности образовательной организации, утвержденного в установленном законодательством Российской Федерации порядке, или бюджетной сметы образовательной организации  (пп. «г» п.1. ч.2 ст. 29 273-ФЗ, пп. «г»,  п. 3.10 Требований от 14.08.2020 № 831);	',
          'Не имеется'
        ]
      ]
    },
    {
      title: 'Вакантные места для приема (перевода) обучающихся',
      content: [
        [
          'Информация о количестве вакантных мест для приема (перевода) обучающихся по каждой реализуемой образовательной программе, по имеющимся в образовательной организации бюджетным или иным ассигнованиям.',
          '0 мест'
        ]
      ]
    },
    {
      title: 'Доступная среда',
      content: [
        [
          'Главная страница подраздела “Доступная среда” должна содержать информацию о специальных условиях для обучения инвалидов и лиц с ограниченными возможностями здоровья, в том числе:',
          'Образовательная детальность осуществляется дистанционным способом'
        ],
        [
          '–   о специально оборудованных учебных кабинетах; –  об объектах для проведения практических занятий, приспособленных для использования инвалидами и лицами с ограниченными возможностями здоровья; –  о библиотеке(ах), приспособленных для использования инвалидами и лицами с ограниченными возможностями здоровья; –  об объектах спорта, приспособленных для использования инвалидами и лицами с ограниченными возможностями здоровья; – о средствах обучения и воспитания, приспособленных для использования инвалидами и лицами с ограниченными возможностями здоровья; –   об обеспечении беспрепятственного доступа в здания образовательной организации; –   о специальных условиях питания; –   о специальных условиях охраны здоровья; – о доступе к информационным системам и информационно-телекоммуникационным сетям, приспособленным для использования инвалидами и лицами с ограниченными возможностями здоровья; –   об электронных образовательных ресурсах, к которым обеспечивается доступ инвалидов и лиц с ограниченными возможностями здоровья; –  о наличии специальных технических средств обучения коллективного и индивидуального пользования; –  о наличии условий для беспрепятственного доступа в общежитие, интернат; – о количестве жилых помещений в общежитии, интернате, приспособленных для использования инвалидами и лицами с ограниченными возможностями здоровья.',
          'Не имеется'
        ]
      ]
    },
    {
      title: 'Международное сотрудничество',
      content: [
        [
          '- о заключенных и планируемых к заключению договорах с иностранными и (или) международными организациями по вопросам образования и науки (при наличии) (в т.ч. п. 14 постановления от 20.10.2021 № 1082); - о международной аккредитации образовательных программ (при наличии).',
          'Международное сотрудничество не осуществляется'
        ]
      ]
    }
  ]

  const renderSection = (v: ISection, i: number) => {
    return (
      <TabPanel key={i}>
        <VStack spacing={6} pt={12} align={'flex-start'}>
          <Text textStyle={'h3'}>{v.title}</Text>
          <TableContainer
            // overflowX='hidden'
            whiteSpace='initial'
            w='full'
            borderWidth={1}
            borderColor={'lightGray'}
            rounded={'sm'}
            textStyle={'tag'}
          >
            <Table variant='striped' size='sm' colorScheme='blackAlpha'>
              <Tbody>
                {v.content.map((d, i) => (
                  <Tr key={i} verticalAlign={'top'}>
                    <Td>{d[0]}</Td>
                    <Td>{d[1]}</Td>
                    <Td>{d[2]}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </VStack>
      </TabPanel>
    )
  }

  return (
    <PageContentWrapper>
      <ContentContainer
        borderBottomRadius={{ base: 'sm', lg: 'lg' }}
        bg='lightGray'
        backBg='white'
      >
        <BlackPageHeader title='Сведения об образовательной организации' />
      </ContentContainer>
      <ContentContainer
        borderBottomRadius={{ base: 'sm', lg: 'lg' }}
        bg='white'
        pb={12}
        pt={12}
      >
        <Tabs w='full' variant='soft-rounded' colorScheme='gray' size='sm'>
          <TabList border={'none'}>
            <VStack
              align={'flex-start'}
              justify={'flex-start'}
              textAlign={'start'}
              spacing={0}
              p={4}
            >
              {data.map((v, i) => (
                <Tab px={4} textAlign={'start'} key={i}>
                  {v.title}
                </Tab>
              ))}
            </VStack>
          </TabList>

          <TabPanels>{data.map(renderSection)}</TabPanels>
        </Tabs>
      </ContentContainer>
    </PageContentWrapper>
  )
}

export default Info
